import { Children, ReactNode, isValidElement } from 'react';
import { Outlet } from 'react-router';
import { Box, DrawerContent, DrawerContentProps } from '../../../atoms';
import { SideOverlayBody } from './side-overlay-body';
import { SideOverlayFooter } from './side-overlay-footer';
import { SideOverlayHeader } from './side-overlay-header';

export function SideOverlayContent({
  children,
  isFooterSticky = true,
  haveTransition = true,
  ...props
}: DrawerContentProps & {
  isFooterSticky?: boolean;
  haveTransition?: boolean;
}): JSX.Element {
  let header: ReactNode = null;
  let body: ReactNode = null;
  let footer: ReactNode = null;
  let outlet: ReactNode = null;

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === SideOverlayHeader) {
      header = child;
    }
    if (child.type === SideOverlayBody) {
      body = child;
    }
    if (child.type === SideOverlayFooter) {
      footer = child;
    }
    if (child.type === Outlet) {
      outlet = child;
    }
  });
  return (
    <DrawerContent
      transform={haveTransition ? 'inherit' : 'none !important'}
      overflowX="hidden"
      {...props}
    >
      <Box h="100%" overflow={isFooterSticky ? 'auto' : 'initial'}>
        {header && header}
        {body && body}
      </Box>

      {footer && footer}
      {outlet && outlet}
    </DrawerContent>
  );
}
